module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-row', [_c('b-navbar-nav'), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h5', {
    staticClass: "page-title mb-2"
  }, [_c('b', [_vm._v("Common BL Dash")])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Branch")]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-1",
    attrs: {
      "list": _vm.$store.getters['common/getAllFilterBranchList'],
      "id": "branchfilter",
      "option-value": "value",
      "option-text": "text",
      "placeholder": "All"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.branchFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "branchFilter", $$v)
      },
      expression: "Filter.branchFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Sob Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.SOBStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select SOB Status"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.SobFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "SobFilter", $$v)
      },
      expression: "Filter.SobFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Prealert Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.PrealertStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Prealert Status"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.prealertStatus),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "prealertStatus", $$v)
      },
      expression: "Filter.prealertStatus"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Billing Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.BillingStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Billing Status"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.isFinalBillingStatus),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "isFinalBillingStatus", $$v)
      },
      expression: "Filter.isFinalBillingStatus"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', {
    attrs: {
      "for": "dateDropdown"
    }
  }, [_vm._v("SI Due Date:")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.next7Days,
      "id": "SiDueDateFilter",
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select SI Due Date"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.SiDueDateFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "SiDueDateFilter", $$v)
      },
      expression: "Filter.SiDueDateFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', {
    attrs: {
      "for": "dateDropdown"
    }
  }, [_vm._v("TR Due Date:")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.next7Days,
      "id": "TrDueDateFilter",
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select TR Due Date"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.TrDueDateFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "TrDueDateFilter", $$v)
      },
      expression: "Filter.TrDueDateFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', {
    attrs: {
      "for": "dateDropdown"
    }
  }, [_vm._v("VGM Due Date:")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.next7Days,
      "id": "VgmDueDateFilter",
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select VGM Due Date"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.VgmDueDateFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "VgmDueDateFilter", $$v)
      },
      expression: "Filter.VgmDueDateFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [((_vm.$sessionsStorage.get('cust_username') == 'rathishnair' || (_vm.$sessionsStorage.get('designation') == 'Admin' &&
    _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh') || _vm.$sessionsStorage.get('designation') == 'Admin')) ? _c('b-button', {
    staticClass: "pull-right ml-2 mt-5",
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.sendSlinePaymentRequest
    }
  }, [_vm._v("Send Sline\n          Payment\n          "), (_vm.isLoading) ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    ref: "search",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type to Search Assignment"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.commonFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "commonFilter", $$v)
      },
      expression: "Filter.commonFilter"
    }
  }), _vm._v(" "), _c('b-input-group-append', {
    staticClass: "mr-1"
  }, [_c('b-button', {
    attrs: {
      "disabled": !_vm.Filter.commonFilter
    },
    on: {
      "click": _vm.filterClear
    }
  }, [_vm._v("Clear")])], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "5"
    }
  }, [_c('b-button', {
    staticClass: "pull-right ml-1",
    class: ' pull-right mb-1' + _vm.visible ? null : 'collapsed',
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": _vm.Filter.userFilter ||
        _vm.Filter.branchFilter ||
        _vm.Filter.prealertStatus ||
        _vm.Filter.SobFilter ||
        _vm.Filter.isFinalBillingStatus ||
        _vm.Filter.SiDueDateFilter ||
        _vm.Filter.TrDueDateFilter ||
        _vm.Filter.VgmDueDateFilter ||
        _vm.Filter.liner_bl_release_statusFilter ||
        _vm.Filter.line_inv_statusFilter ||
        _vm.Filter.commonFilter ||
        _vm.Filter.createdAtRange.startDate ||
        _vm.Filter.createdAtRange.endDate ?
        'outline-danger' :
        'outline-primary',
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v(_vm._s(_vm.Filter.userFilter ||
    _vm.Filter.branchFilter ||
    _vm.Filter.prealertStatus ||
    _vm.Filter.SobFilter ||
    _vm.Filter.isFinalBillingStatus ||
    _vm.Filter.SiDueDateFilter ||
    _vm.Filter.TrDueDateFilter ||
    _vm.Filter.VgmDueDateFilter ||
    _vm.Filter.liner_bl_release_statusFilter ||
    _vm.Filter.line_inv_statusFilter ||
    _vm.Filter.commonFilter ||
    _vm.Filter.createdAtRange.startDate ||
    _vm.Filter.createdAtRange.endDate ?
    "Filter ON" :
    "Filter OFF"))]), _vm._v(" "), (_vm.JOBList.length > 0) ? _c('b-button', {
    staticClass: "pull-right mb-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName !== 'Export As Excel',
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('checkJobPendency', 'Export As Excel')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.ExcelBtnName) + "\n            "), (_vm.ExcelBtnName !== 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.JOBList.length > 0) ? _c('b-button', {
    staticClass: "pull-right mb-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnNameCustom !== 'SI VGM Pending',
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReportsCustom('checkJobPendency', 'SI VGM Pending')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.ExcelBtnNameCustom) + "\n            "), (_vm.ExcelBtnNameCustom !== 'SI VGM Pending') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.$sessionsStorage.get('userId')) ? _c('userBasedClient', {
    attrs: {
      "PMC_title": 'User Summary - ' + _vm.$sessionsStorage.get('employeeName'),
      "PMC_USERID": _vm.Filter.userFilter,
      "PMC_USERNAME": _vm.$sessionsStorage.get('nameUser'),
      "PMC_USERDESIG": _vm.$sessionsStorage.get('designation'),
      "PMC_BranchClientPre": _vm.$sessionsStorage.get('branchclientPre'),
      "PMC_TransportTypePre": _vm.$sessionsStorage.get('transportTypePre'),
      "PMC_UserEmpName": _vm.$sessionsStorage.get('employeeName'),
      "PMC_UserEmpCode": _vm.$sessionsStorage.get('employeeCode')
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "1"
    }
  }, [_c('h5', [(!_vm.isLoading) ? _c('small', [_vm._v(_vm._s(_vm.totalData) + " Entries")]) : _vm._e()])])], 1), _vm._v(" "), (_vm.visible) ? _c('div', [_c('b-card', [_c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    on: {
      "update": function($event) {
        _vm.getAssignmentPendencyList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.createdAtRange),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "createdAtRange", $$v)
      },
      expression: "Filter.createdAtRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [(_vm.activeUserPreference) ? _c('label', [_c('b', [_vm._v("Created User Filter")])]) : _vm._e(), _vm._v(" "), (_vm.activeUserPreference) ? _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "addedUserFilter",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Created User"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.userFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "userFilter", $$v)
      },
      expression: "Filter.userFilter"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "dateDropdown"
    }
  }, [_vm._v("SI Due Date:")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.next7Days,
      "id": "SiDueDateFilter",
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select SI Due Date"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.SiDueDateFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "SiDueDateFilter", $$v)
      },
      expression: "Filter.SiDueDateFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "dateDropdown"
    }
  }, [_vm._v("TR Due Date:")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.next7Days,
      "id": "TrDueDateFilter",
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select TR Due Date"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.TrDueDateFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "TrDueDateFilter", $$v)
      },
      expression: "Filter.TrDueDateFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "dateDropdown"
    }
  }, [_vm._v("VGM Due Date:")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.next7Days,
      "id": "VgmDueDateFilter",
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select VGM Due Date"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.VgmDueDateFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "VgmDueDateFilter", $$v)
      },
      expression: "Filter.VgmDueDateFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "liner-bl-release-status"
    }
  }, [_vm._v("Liner BL Release Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.mblInvoiceStatus,
      "id": "liner_bl_release_status",
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select MBL Status"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.liner_bl_release_statusFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "liner_bl_release_statusFilter", $$v)
      },
      expression: "Filter.liner_bl_release_statusFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "liner-bl-release-status"
    }
  }, [_vm._v("Line Invoice Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.lineInvoiceStatus,
      "id": "line_inv_status",
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select Line Invoice Status"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.line_inv_statusFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "line_inv_statusFilter", $$v)
      },
      expression: "Filter.line_inv_statusFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "ml-1 pull-right",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 row table-wrapper-scroll-x my-custom-scrollbar"
  }, [_c('b-table', {
    staticClass: "table-background position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "fields": _vm.columnMain,
      "items": _vm.JOBList,
      "per-page": _vm.pagination.perPage,
      "filter": _vm.filter
    },
    on: {
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.pagination.currentPage - 1) * _vm.pagination.perPage))])]
      }
    }, {
      key: "RaisedFrom",
      fn: function(row1) {
        return [_c('tr', {
          class: {
            blink: _vm.isBlinking(row1.item)
          }
        }, [_c('td', [_c('div', {
          class: {
            'blink-circle': _vm.shouldBlink(row1.item)
          }
        })])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(row1.item.RaisedFrom))]), _c('br'), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row1.item.SobStatus == 'Sailed' ? 'success' : 'danger'
          }
        }, [_c('b', [_vm._v("SOB:" + _vm._s(row1.item.SobStatus))])]), _c('br'), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row1.item.BillingStatus == 'Completed' ? 'success' : 'danger'
          }
        }, [_c('b', [_vm._v("Billing:" + _vm._s(row1.item.BillingStatus))])]), _c('br'), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": (row1.item.PrealertStatus == 'Prealert Sent (FF)' || row1.item.PrealertStatus == 'Prealert Sent (CON)') ? 'success' : 'danger'
          }
        }, [_c('b', [_vm._v("Prealert:" + _vm._s(row1.item.PrealertStatus))])]), _c('br'), _vm._v(" "), (row1.item.isConsolidation == 0) ? _c('span', [_vm._v(_vm._s("Prealert : " + row1.item.IsPrealertSend))]) : _vm._e(), _c('br'), _vm._v(" "), (row1.item.isConsolidation == 1) ? _c('span', [_vm._v(_vm._s("Prealert : " + row1.item.IsCONprealertSend))]) : _vm._e(), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Manifest : " + row1.item.IsManifestationStatus))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Transport Type : " + row1.item.TransportType))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Job Type : " + row1.item.JobType))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("FCL/LCL : " + row1.item.FCL_LCL))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Stuffing Type : " + row1.item.StuffingType))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Delivery Mode : " + row1.item.DeliveryMode))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Delivery Terms : " + row1.item.DeliveryTerms))]), _vm._v(" "), _c('span', [_vm._v("Billing : ")]), _vm._v(" "), (row1.item.TallyBillingSeries) ? _c('div', {
          staticClass: "text-left"
        }, [(row1.item.TallyBillingSeries) ? _c('div', _vm._l((row1.item.TallyBillingSeries.split(',')), function(item1, index) {
          return _c('span', {
            key: index
          }, [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_c('b', [_vm._v(_vm._s(item1 == "" ? "-------" : item1))])]), _c('br')], 1)
        })) : _vm._e()]) : _c('div', {
          staticClass: "text-left"
        }, [_c('b-badge', {
          attrs: {
            "variant": "light"
          }
        }, [_vm._v("-------")])], 1), _vm._v(" "), _c('b-button', {
          staticClass: "ml-1",
          staticStyle: {
            "margin-left": "auto",
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-danger"
          },
          on: {
            "click": function($event) {
              _vm.openModal(row1.item)
            }
          }
        }, [_vm._v("\n              Update\n            ")]), _vm._v(" "), _c('UpdateCBModal', {
          ref: "updateCBModal",
          attrs: {
            "common_id": row1.item.common_id,
            "allModuleId": row1.item.allModuleId,
            "JobNo": row1.item.JOBNO,
            "booking_id": row1.item.booking_id,
            "getin_due_date": row1.item.common_getin_due_date || row1.item.cb_getin_due_date,
            "si_submission_date": row1.item.common_si_submission_date || row1.item.cb_si_submission_date,
            "vgm_submission_date": row1.item.common_vgm_submission_date || row1.item.cb_vgm_submission_date,
            "tr_submission_date": row1.item.common_tr_submission_date || row1.item.cb_tr_submission_date,
            "liner_bl_release_status": row1.item.common_liner_bl_release_status || row1.item.cb_liner_bl_release_status,
            "line_inv_status": row1.item.common_line_inv_status || row1.item.cb_line_inv_status,
            "linerBLNumber": row1.item.MblNo || '',
            "blType": row1.item.blType || '',
            "frghtTermsLiner": row1.item.frghtTermsLiner || '',
            "linerBLupload": row1.item.linerBLupload || '',
            "mbl_release_date": row1.item.mbl_release_date || '',
            "mbl_date": row1.item.mbl_date || ''
          },
          on: {
            "update": _vm.updateData
          }
        }), _vm._v(" "), _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.showDocModal(row1.item)
            }
          }
        }, [_vm._v("Summary & Documents")]), _vm._v(" "), _c('Assignment-Summary', {
          attrs: {
            "title": 'Shipment Summary Tracking - ',
            "fk_all_module_id": row1.item.allModuleId,
            "jb_series": row1.item.JobNo
          }
        }), _vm._v(" "), (row1.item.allModuleId) ? _c('JobWisePaymentsDetails', {
          attrs: {
            "allModuleId": Number(row1.item.allModuleId),
            "JobNo": row1.item.JobNo
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.allModuleId) ? _c('ContainerSummary', {
          attrs: {
            "PMC_title": 'Container Summary Job No - ' + row1.item.JobNo,
            "PMC_JOBID": row1.item.allModuleId.toString(),
            "PMC_JOBNO": row1.item.JobNo,
            "PMC_JOBDATE": row1.item.JobDate,
            "PMC_JOBTYPE": row1.item.JobType,
            "PMC_AgentType": '',
            "PMC_Client": row1.item.ClientName,
            "PMC_Sline": row1.item.ShippingLine
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.allModuleId) ? _c('RejectInvTallyBillSummary', {
          attrs: {
            "PMC_title": 'Invoice Rejection Log Summary Job No - ' + row1.item.ffExportFclSeries,
            "PMC_JOBID": row1.item.allModuleId.toString(),
            "PMC_JOBNO": row1.item.JobNo,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.allModuleId) ? _c('InvExpSummary', {
          attrs: {
            "PMC_title": 'Inv Exp Summary Job No - ' + row1.item.JobNo,
            "PMC_JOBID": row1.item.allModuleId.toString(),
            "PMC_JOBNO": row1.item.JobNo,
            "PMC_JOBDATE": row1.item.JobDate,
            "PMC_JOBTYPE": row1.item.JobType,
            "PMC_AgentType": '',
            "PMC_Client": '',
            "PMC_Sline": row1.item.ShippingLine
          }
        }) : _vm._e()]
      }
    }, {
      key: "BookingNo",
      fn: function(row2) {
        return [_c('span', {
          style: (row2.item.SubscriptionId ? 'color: blue;font-weight:bold' : ''),
          on: {
            "click": function($event) {
              row2.item.SubscriptionId ? _vm.goToSubscriptionPage(row2.item) : ''
            }
          }
        }, [_vm._v(_vm._s(row2.item.BookingNo))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Billing Type : " + row2.item.IsBillingTypeStatus)), _c('br')]), _vm._v(" "), (
          row2.item.IsBillingTypeStatus == 'Local' ||
          row2.item.IsBillingTypeStatus == 'Both'
        ) ? _c('span', [_vm._v(_vm._s("Local : " +
          (row2.item.billingTypeMain == "Local Billing" ? "Done" : "Pending"))), _c('br')]) : _vm._e(), _vm._v(" "), (
          row2.item.IsBillingTypeStatus == 'Overseas' ||
          row2.item.IsBillingTypeStatus == 'Both'
        ) ? _c('span', [_vm._v(_vm._s("Overseas : " +
          (row2.item.IsManifestation == "Yes" ? "Done" : "Pending"))), _c('br')]) : _vm._e(), _vm._v(" "), (row2.item.blType) ? _c('span', [_vm._v(_vm._s("BL Type : " + row2.item.blType)), _c('br')]) : _vm._e(), _vm._v(" "), (row2.item.frghtTermsHbl) ? _c('span', [_vm._v(_vm._s("Freight Terms Hbl : " + row2.item.frghtTermsHbl)), _c('br')]) : _vm._e(), _vm._v(" "), (row2.item.frghtTermsMbl) ? _c('span', [_vm._v(_vm._s("Freight Terms Mbl : " + row2.item.frghtTermsMbl)), _c('br')]) : _vm._e(), _vm._v(" "), (row2.item.frghtTermsLiner) ? _c('span', [_vm._v(_vm._s("Freight Terms Liner : " + row2.item.frghtTermsLiner)), _c('br')]) : _vm._e()]
      }
    }, {
      key: "JOBNO",
      fn: function(row3) {
        return [_c('tr', {
          class: {
            blink: _vm.isBlinking(row3.item)
          },
          on: {
            "click": function($event) {
              _vm.goPage(row3.item)
            }
          }
        }, [_c('td', [_c('span', [_vm._v(_vm._s("JOBNO : " + row3.item.JobNo))]), _c('br')])]), _vm._v(" "), _c('span', [_vm._v(_vm._s("JOBDate : " + row3.item.JobDate))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("RaisedBy : " + row3.item.RaisedBy))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("MBLNO : " + row3.item.MblNo))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("HBLNO : " + row3.item.HblNo))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Tot Cont : " + row3.item.TotalContainerNo))]), _c('br'), _vm._v(" "), (row3.item.FreightContainers) ? _c('div', {
          staticClass: "text-left"
        }, [(row3.item.FreightContainers) ? _c('div', _vm._l((row3.item.FreightContainers.split(',')), function(item1, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item1 == "" ? "-------" : item1) + "\n                    ")])], 1), _vm._v(" "), (row3.item.allModuleId && item1) ? _c('ContaierWebLogSummary', {
            attrs: {
              "PMC_title": 'Container Event Summary Job No - ' + row3.item.JobNo,
              "PMC_JOBID": row3.item.allModuleId.toString(),
              "PMC_JOBNO": row3.item.JobNo,
              "PMC_CONTNO": item1,
              "PMC_JOBDATE": '',
              "PMC_JOBTYPE": '',
              "PMC_AgentType": '',
              "PMC_Client": '',
              "PMC_Sline": ''
            }
          }) : _vm._e()], 1)
        })) : _vm._e()]) : _c('div', {
          staticClass: "text-left"
        }, [_c('b-badge', {
          attrs: {
            "variant": "light"
          }
        }, [_vm._v("-------")])], 1)]
      }
    }, {
      key: "clientName",
      fn: function(row4) {
        return [_c('span', [_vm._v(_vm._s(row4.item.ClientName))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("FF Status : " + row4.item.FFInvStatus))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("CC Status : " + row4.item.CCInvStatus))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("TPT Status : " + row4.item.TPTInvStatus))]), _c('br')]
      }
    }, {
      key: "shippingLine",
      fn: function(row5) {
        return [_c('span', [_vm._v(_vm._s(row5.item.ShippingLine))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Vessel Voyage : " + row5.item.VesselVoyage))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("SINVNO : "))]), _c('br'), _vm._v(" "), (row5.item.SINVNO) ? _c('div', {
          staticClass: "text-left"
        }, [(row5.item.SINVNO) ? _c('div', _vm._l((row5.item.SINVNO.split(',')), function(item1, index) {
          return _c('span', {
            key: index
          }, [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_c('b', [_vm._v(_vm._s(item1 == "" ? "-------" : item1))])]), _c('br')], 1)
        })) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s("SBILLNO : "))]), _c('br'), _vm._v(" "), (row5.item.SBILLNO) ? _c('div', {
          staticClass: "text-left"
        }, [(row5.item.SBILLNO) ? _c('div', _vm._l((row5.item.SBILLNO.split(',')), function(item1, index) {
          return _c('span', {
            key: index
          }, [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_c('b', [_vm._v(_vm._s(item1 == "" ? "-------" : item1))])]), _c('br')], 1)
        })) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s("CUST_SEAL_NO : "))]), _c('br'), _vm._v(" "), (row5.item.CUST_SEAL_NO) ? _c('div', {
          staticClass: "text-left"
        }, [(row5.item.CUST_SEAL_NO) ? _c('div', _vm._l((row5.item.CUST_SEAL_NO.split(',')), function(item1, index) {
          return _c('span', {
            key: index
          }, [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_c('b', [_vm._v(_vm._s(item1 == "" ? "-------" : item1))])]), _c('br')], 1)
        })) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s("LINE_SEAL_NO : "))]), _c('br'), _vm._v(" "), (row5.item.LINE_SEAL_NO) ? _c('div', {
          staticClass: "text-left"
        }, [(row5.item.LINE_SEAL_NO) ? _c('div', _vm._l((row5.item.LINE_SEAL_NO.split(',')), function(item1, index) {
          return _c('span', {
            key: index
          }, [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_c('b', [_vm._v(_vm._s(item1 == "" ? "-------" : item1))])]), _c('br')], 1)
        })) : _vm._e()]) : _vm._e()]
      }
    }, {
      key: "POR",
      fn: function(row6) {
        return [_c('span', [_vm._v(_vm._s("POR : " + row6.item.POR))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("POL : " + row6.item.POL))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("POD : " + row6.item.POD))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("FPOD : " + row6.item.FPOD))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Inv Reverse : "))]), _c('br'), _vm._v(" "), (row6.item.invReverse) ? _c('div', {
          staticClass: "text-left"
        }, [(row6.item.invReverse) ? _c('div', _vm._l((row6.item.invReverse.split(',')), function(item1, index) {
          return _c('span', {
            key: index
          }, [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_c('b', [_vm._v(_vm._s(item1 == "" ? "-------" : item1))])]), _c('br')], 1)
        })) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s("Inv Expense : "))]), _c('br'), _vm._v(" "), (row6.item.invExpense) ? _c('div', {
          staticClass: "text-left"
        }, [(row6.item.invExpense) ? _c('div', _vm._l((row6.item.invExpense.split(',')), function(item1, index) {
          return _c('span', {
            key: index
          }, [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_c('b', [_vm._v(_vm._s(item1 == "" ? "-------" : item1))])]), _c('br')], 1)
        })) : _vm._e()]) : _vm._e()]
      }
    }, {
      key: "vgmcut_off_date_est",
      fn: function(row10) {
        return [_c('span', {
          class: row10.item.VgmSubmissionDateActual == 'Pending' ? 'error' : '',
          on: {
            "click": function($event) {
              _vm.goVGMPage(row10.item)
            }
          }
        }, [_vm._v(_vm._s(row10.item.VgmSubmissionDateActual))]), _vm._v("/\n            "), _c('span', {
          class: row10.item.VgmCutOffDateEst == 'Pending' ? 'error' : '',
          on: {
            "click": function($event) {
              _vm.goVGMPage(row10.item)
            }
          }
        }, [_vm._v(_vm._s(row10.item.VgmCutOffDateEst))]), _c('br'), _vm._v(" "), _c('span', {
          class: row10.item.VgmDueDate == 'Pending' ? 'error' : ''
        }, [_vm._v(_vm._s("VGM Due date : " +
          row10.item.VgmDueDate))])]
      }
    }, {
      key: "si_cutoff_est",
      fn: function(row11) {
        return [_c('span', {
          class: row11.item.SiSubmissiondateActual == 'Pending' ? 'error' : '',
          on: {
            "click": function($event) {
              _vm.goVGMPage(row11.item)
            }
          }
        }, [_vm._v(_vm._s(row11.item.SiSubmissiondateActual))]), _vm._v("/\n            "), _c('span', {
          class: row11.item.SiCutOffEst == 'Pending' ? 'error' : '',
          on: {
            "click": function($event) {
              _vm.goVGMPage(row11.item)
            }
          }
        }, [_vm._v(_vm._s(row11.item.SiCutOffEst))]), _c('br'), _vm._v(" "), _c('span', {
          class: row11.item.SiDueDate == 'Pending' ? 'error' : ''
        }, [_vm._v(_vm._s("SI Due date : " +
          row11.item.SiDueDate))])]
      }
    }, {
      key: "tr_cutoff_date_est",
      fn: function(row12) {
        return [_c('span', {
          class: row12.item.TrSubmissiondateActual == 'Pending' ? 'error' : '',
          on: {
            "click": function($event) {
              _vm.goVGMPage(row12.item)
            }
          }
        }, [_vm._v(_vm._s(row12.item.TrSubmissiondateActual))]), _vm._v("/\n            "), _c('span', {
          class: row12.item.TrCutOffDateEst == 'Pending' ? 'error' : '',
          on: {
            "click": function($event) {
              _vm.goVGMPage(row12.item)
            }
          }
        }, [_vm._v(_vm._s(row12.item.TrCutOffDateEst))]), _c('br'), _vm._v(" "), _c('span', {
          class: row12.item.TrDueDate == 'Pending' ? 'error' : ''
        }, [_vm._v(_vm._s("TR Due date : " +
          row12.item.TrDueDate))])]
      }
    }, {
      key: "handoverDate_actual",
      fn: function(row12) {
        return [_c('span', {
          class: row12.item.HandoverDateActual == 'Pending' ? 'error' : ''
        }, [_vm._v(_vm._s(row12.item.HandoverDateActual))]), _vm._v("/\n            "), _c('span', {
          class: row12.item.HandoverCutOffDateEst == 'Pending' ? 'error' : ''
        }, [_vm._v(_vm._s(row12.item.HandoverCutOffDateEst))])]
      }
    }, {
      key: "oe_payment_status",
      fn: function(row13) {
        return [_c('span', [_vm._v(_vm._s("Payment Status : " + row13.item.SlinePaymentStatus))]), _c('br'), _vm._v(" "), _c('span', {
          class: row13.item.SlineFirstPayDate == 'Pending' ? 'error' : ''
        }, [_vm._v(_vm._s("Payment First Date : " +
          row13.item.SlineFirstPayDate))]), _vm._v(" "), _c('span', {
          class: row13.item.OfFirstPaymentDate == 'Pending' ? 'error' : ''
        }, [_vm._v(_vm._s("First Payment Paid Date : " +
          row13.item.OfFirstPaymentDate))])]
      }
    }, {
      key: "SOB",
      fn: function(row14) {
        return [_c('span', {
          class: row14.item.SOB == 'Pending' ? 'error' : ''
        }, [_vm._v(_vm._s("P44 : " + row14.item.SOB))]), _c('br'), _vm._v(" "), _c('span', {
          class: row14.item.SysSOB == 'Pending' ? 'error' : ''
        }, [_vm._v(_vm._s("Sys : " + row14.item.SysSOB))])]
      }
    }, {
      key: "SysETA_actual",
      fn: function(row15) {
        return [_c('span', {
          class: row15.item.EtaDestinationEstimated == 'Pending' ? 'error' : ''
        }, [_vm._v(_vm._s("OF ETA Estimated : " + row15.item.EtaDestinationEstimated))]), _c('br'), _vm._v(" "), _c('span', {
          class: row15.item.EtaDestinationActual == 'Pending' ? 'error' : ''
        }, [_vm._v(_vm._s("OF ETA Actual : " + row15.item.EtaDestinationActual))]), _c('br'), _vm._v(" "), _c('span', {
          class: row15.item.SysETA_estimated == 'Pending' ? 'error' : ''
        }, [_vm._v(_vm._s("Sys ETA Estimated : " + row15.item.SysETA_estimated))]), _c('br'), _vm._v(" "), _c('span', {
          class: row15.item.SysETA_actual == 'Pending' ? 'error' : ''
        }, [_vm._v(_vm._s("Sys ETA Actual : " + row15.item.SysETA_actual))]), _c('br'), _vm._v(" "), _c('span', {
          class: row15.item.EtaLoadPortInitial == 'Pending' ? 'error' : ''
        }, [_vm._v(_vm._s("OF ETA Load Port Initial : " + row15.item.EtaLoadPortInitial))]), _c('br'), _vm._v(" "), _c('span', {
          class: row15.item.EtaLoadPortActual == 'Pending' ? 'error' : ''
        }, [_vm._v(_vm._s("OF ETA Load Port Actual : " + row15.item.EtaLoadPortActual))]), _c('br')]
      }
    }])
  }), _vm._v(" "), _c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "id": "doc",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": 'Assignment Summary & Documents - ' + _vm.JOBSERIES
    }
  }, [(_vm.ALLMODULE) ? _c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close\n      ")])], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cfae027","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/Pendency/jobCommonPendency.vue
// module id = 2665
// module chunks = 0